export const formatNumberAsCurrency = (number, hasDecimals = false) => {
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(number);

  return formattedNumber === `$NaN` ? '$0' : formattedNumber;
};

export const formatNumberWithCommas = (number) => {
  const parts = number.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const createInitialValues = (source) =>
  Object.entries(source).map(([name, { original, type, label }]) => ({
    name,
    original,
    step: label === 'Conversion Impact' || label === '"Bad" Sessions' ? 4 : 0,
    new: type === 'number' ? original : parseFloat(original),
  }));

export const getGrowRevenueResults = (calculatorValuesByName) => {
  const { monthlySessions, cvr, orderValue, repeatCustomers, grossMargin } = calculatorValuesByName;

  const getInt = (value) => parseInt(value, 10);
  const getFloat = (value) => (value ? parseFloat(value) : 0);
  const getDecimal = (value) => parseFloat(value) * 0.01;
  const getProfit = (version) => {
    let adjustedRepeatCustomers = getDecimal(repeatCustomers[version]);
    if (adjustedRepeatCustomers === 0) adjustedRepeatCustomers = 1;

    return (
      getInt(monthlySessions[version]) *
      getDecimal(cvr[version]) *
      getFloat(orderValue[version]) *
      adjustedRepeatCustomers *
      getDecimal(grossMargin[version])
    );
  };
  const getMultiplier = (originalValue, newValue) => (newValue - originalValue) / originalValue;

  const startingProfit = getProfit('original');
  const newProfit = getProfit('new');

  return {
    conversionIncrease: startingProfit * getMultiplier(cvr.original, cvr.new),
    orderValueIncrease: startingProfit * getMultiplier(orderValue.original, orderValue.new),
    repeatCustomersIncrease: startingProfit * getMultiplier(repeatCustomers.original, repeatCustomers.new),
    totalIncrease: newProfit - startingProfit,
  };
};
